import { useLiveQuery } from 'dexie-react-hooks';
import { DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';
import { db } from '../init';

export const useGetDataPointTree = (): DataPointTreeItem[] | undefined => {
	return useLiveQuery(() => db.dataPointTree.toArray());
};
